export interface UniversalSearchItem {
  id: string;
  label: string;
  type: "customer" | "product" | "invoice" | "order" | "barcode" | "ledger" | "supplier" | "page";
  commandId: string;
  payload?: unknown;
  keywords?: string[];
}

export class UniversalSearchService {
  private items: UniversalSearchItem[] = [];

  setItems(items: UniversalSearchItem[]) {
    this.items = items;
  }

  search(query: string) {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return this.items.slice(0, 20);

    return this.items
      .filter((item) => {
        const haystack = [
          item.label,
          item.type,
          ...(item.keywords || []),
          String(item.payload || ""),
        ]
          .join(" ")
          .toLowerCase();
        return haystack.includes(normalized);
      })
      .slice(0, 30);
  }
}

export const universalSearchService = new UniversalSearchService();
